import { Language } from 'translations/constants'

// app defaults
export const DEFAULT_LANGUAGE: Language = Language.EN

// network defaults
export const DEFAULT_NETWORK_ID = 690

export const DEFAULT_GAS_BUFFER = 5000
export const DEFAULT_GAS_LIMIT = 500000
export const DEFAULT_CROSSMARGIN_GAS_BUFFER_PCT = 5

// ui defaults
export const DEFAULT_SEARCH_DEBOUNCE_MS = 300
export const DEFAULT_REQUEST_REFRESH_INTERVAL = 30000 // 30s
export const DEFAULT_CRYPTO_DECIMALS = 4
export const DEFAULT_FIAT_DECIMALS = 2
export const DEFAULT_NUMBER_DECIMALS = 2
export const DEFAULT_PERCENT_DECIMALS = 2
export const DEFAULT_TOKEN_DECIMALS = 18

// for Trading History
export const DEFAULT_NUMBER_OF_TRADES: number = 32
export const MAX_TIMESTAMP: number = 8640000000000000

// for Fee History
export const DEFAULT_NUMBER_OF_FUTURES_FEE: number = 9999

// for mobile leaderboard
export const DEFAULT_LEADERBOARD_ROWS = 20

// for perps v2
export const DEFAULT_DELAYED_EXECUTION_BUFFER = 15
export const DEFAULT_DELAYED_CANCEL_BUFFER = 10

export const CROSS_MARGIN_ENABLED = process.env.NODE_ENV !== 'production'
export const ORDERS_WARNING_DISABLED = true

export const DEFAULT_LEVERAGE = '1'

export const SWAP_QUOTE_BUFFER = 0.2

export const MARKET_SELECTOR_HEIGHT_MOBILE = 58

export const POLL_INTERVAL_MS = 40000

export const DEFAULT_POLL_DELAY_TIME_MS = 0

export const DEFAULT_UPDATE_KLINE_DELAY_TIME_MS = 1000

export const ORDER_TYPES = ['market', 'limit']

export const ORDERBOOK_WIDTH_INCREASEMENT = 0.1

export const DEFAULT_TIME_SPAN = 7

export const LIMIT_ORDER_TRANSACTION_FEE_PERCENT = 0.0 // Unit %
export const MARKET_ORDER_TRANSACTION_FEE_PERCENT = 0.1 // Unit %